module.exports = __webpack_public_path__ + "static/media/photo.7c11197c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Cover/img/photo.png
// module id = 155
// module chunks = 1